import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=guest, obj=user

  useEffect(() => {
    // If returning from Google OAuth callback, let AuthCallback handle it first.
    if (window.location.hash?.includes("session_id=")) { setUser(false); return; }
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => setUser(false));
  }, []);

  // Auth is cookie-based (httpOnly); the session cookie is set by the server.
  const applyAuth = (data) => {
    setUser(data.user);
    return data.user;
  };

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    return applyAuth(data);
  };
  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    return applyAuth(data);
  };
  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { /* best-effort; cookie clears server-side */ }
    setUser(false);
  };

  const impersonate = async (businessId) => {
    const { data } = await api.post(`/admin/impersonate/${businessId}`);
    return applyAuth(data);
  };

  const stopImpersonate = async () => {
    const { data } = await api.post("/auth/stop-impersonation");
    setUser(data.user);
    return data.user;
  };

  return (
    <AuthContext.Provider value={{ user, login, register, logout, setUser, applyAuth, impersonate, stopImpersonate }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
